<template>
    <div class="tw-flex-1 tw-flex tw-flex-col">

        <!--<div class="tw-h-16 tw-cursor-pointer tw-flex tw-items-center tw-p-4 border-default tw-border-b tw-border-gray-200 tw-outline-none hover:tw-bg-blue-50"-->
        <!--    v-on:click="states.showChatDetails = !states.showChatDetails">-->
        <div class="tw-h-16 border-default tw-border-b tw-border-gray-200 tw-outline-none tw-flex tw-items-center tw-justify-between tw-p-4">
            <div class="tw-flex tw-items-center ">
                <img :src="store.chat_image(states.activeChat)" alt="" class="tw-w-8 tw-h-8 tw-rounded-full tw-mr-4">
                <div>
                    <div class="tw-text-left tw-font-semibold">{{store.chat_title(states.activeChat)}}</div>
                    <div class="tw-text-gray-500 " v-if="states.otherIsTyping">{{$text.typing}}</div>
                </div>
            </div>
            <div class="tw-space-x-3 tw-flex tw-items-center ">
                <div v-on:click.prevent="() => store.toggleAutoTranslate()" tabindex="0" class="tw-cursor-pointer tw-rounded-lg tw-px-3 tw-py-1 tw-font-semibold tw-text-gray-700 hover:tw-text-blue-700">
                    {{store.states.autoTranslate ? $text.deactivate_auto_translation : $text.activate_auto_translation}}
                </div>
                <div v-on:click.prevent="() => store.toggleBlock()" tabindex="0" class="tw-cursor-pointer tw-rounded-lg tw-px-3 tw-py-1 tw-font-semibold tw-text-gray-700 hover:tw-text-red-700">
                    {{store.activeChatIsBlocked() ? $text.unblock_user : $text.block_user}}
                </div>
                <!--<div tabindex="0" class="tw-cursor-pointer tw-w-8 tw-h-8 tw-rounded-full hover:tw-bg-blue-50 tw-flex tw-items-center tw-justify-center">-->
                <!--    <i class="bx bx-dots-vertical-rounded tw-text-xl"></i>-->
                <!--</div>-->
            </div>
        </div>

        <div v-if="store.activeChatIsBlocked()" class="space-y-3 tw-flex-1 tw-overflow-auto tw-flex tw-items-center tw-justify-center tw-space-x-3">
            <div v-on:click.prevent="() => store.unblock(store.other_user(states.activeChat))" tabindex="0" class="tw-cursor-pointer tw-rounded tw-bg-red-500 tw-text-white tw-font-bold tw-px-6 tw-py-2">{{$word.unblock_user}}</div>
        </div>

        <div v-else-if="states.activeChat.draft && store.creator(states.activeChat).id !== states.user.id" class="space-y-3 tw-flex-1 tw-overflow-auto tw-flex tw-items-center tw-justify-center tw-space-x-3">
            <div v-on:click.prevent="() => store.accept()" tabindex="0" class="tw-cursor-pointer tw-rounded tw-bg-green-500 tw-text-white tw-font-bold tw-px-6 tw-py-2">{{$word.accept}}</div>
            <div v-on:click.prevent="() => store.block(store.other_user(states.activeChat))" tabindex="0" class="tw-cursor-pointer tw-rounded tw-bg-red-500 tw-text-white tw-font-bold tw-px-6 tw-py-2">{{$word.block_user}}</div>
        </div>

        <div v-else-if="states.showChatDetails" class="space-y-3 tw-flex-1 tw-overflow-auto">
            <div v-for="member in states.activeChat.users" :key="member.id" class="tw-flex tw-items-center tw-p-4 hover:tw-bg-blue hover:tw-bg-opacity-2">
                <img :src="member.avatar" alt="" class="tw-w-16 tw-h-16 tw-rounded-full tw-mr-4">
                <div>
                    <div class="tw-text-left">{{member.name}}</div>
                    <!--<div class="tw-text-gray-500 ">—</div>-->
                </div>
            </div>
        </div>

        <template v-else>
        <div class="tw-flex-1 tw-overflow-auto tw-space-y-2 tw-p-4" ref="messages">
            <div v-if="states.loading_messages" class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                <div>{{$text.loading}}</div>
            </div>
            <div v-else-if="states.activeChat === null" class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                <div>{{$text.select_a_chat}}</div>
            </div>
            <message-item v-else v-for="message in states.messages" :key="message.id" :data="message" :user="states.user"/>
        </div>

        <form class="tw-relative tw-w-full border-default tw-border-t tw-border-gray-200" v-on:submit.prevent="store.sendMessage">
            <input type="file" multiple class="tw-hidden" ref="attachment" v-on:change="store.sendAttachment($event)">
            <div class="tw-space-x-1 tw-flex tw-items-center tw-p-2 focus-within:tw-bg-light-2">
                <div tabindex="0" class="tw-outline-none tw-cursor-pointer tw-p-3 hover:tw-text-blue-600" v-on:click.prevent="$refs.attachment.click()">
                    <i class="bx bx-file tw-text-xl"></i>
                </div>
                <div tabindex="0" class="tw-relative tw-outline-none tw-cursor-pointer tw-p-3 hover:tw-text-blue-600" v-on:click.prevent="store.toggleEmoji">
                    <i class="bx bx-smile tw-text-xl"></i>
                    <div v-show="states.emoji" class="tw-absolute tw-top-0 tw-left-0 tw-z-10" v-on:click.stop>
                        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-z-10">
                            <emoji-picker :native="true" @select="emoji => store.addEmoji(emoji)"/>
                        </div>
                    </div>
                </div>
                <input type="text"
                    v-on:keydown.enter.prevent="store.sendMessage" v-model="states.form.text"
                    v-on:keypress="() => store.broadcastTyping()"
                    :placeholder="$text.send_a_message"
                    class="tw-outline-none tw-border-0 tw-flex-1 tw-rounded tw-p-5 tw-bg-transparent tw-mb-0 tw-resize-none leading-loose"
                />
                <div v-on:click.prevent="store.sendMessage" tabindex="0" class="tw-outline-none tw-cursor-pointer tw-p-3 hover:tw-text-blue-600">
                    <i class="bx bx-send tw-text-xl"></i>
                </div>
            </div>
        </form>

        </template>

    </div>

</template>
<script>
    import store from './messenger-store'
    import MessageItem from "./messenger-message-item";
    import {Picker as EmojiPicker} from 'emoji-mart-vue'

    export default {
        components: {
            MessageItem,
            EmojiPicker,
        },
        created() {
            this.store = store
            this.states = store.states
            store.bus.$on('scroll-to-last-message', () => {
                this.$refs.messages && this.$nextTick(() => {
                    // Todo remove setTimeout
                    setTimeout(() => {
                        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
                    }, 0)
                })
            })
        },
    }
</script>
